import { authedFetch } from '@features/auth/api/authRefresh'

/**
 * DELETE /api/users/me — アカウントの削除 (アカウント完全削除)。
 *
 * サーバ側で Prisma cascade により vault / send / session / device-token 等を一括削除する。
 * 成功時 204 (本関数は void resolve)。失敗時は ApiError を throw。
 */
export const deleteAccount = (): Promise<void> =>
  authedFetch<void>('/users/me', { method: 'DELETE' })
